<nav class="pagination-nav">
    <ul class="pagination-info">
        <li>
            <mat-form-field>
                <mat-select [(value)]="pageSize"  (selectionChange)="onPageSizeChange($event)">
                    <mat-option *ngFor="let size of pageSizeOptions" [value]="size">
                        {{ size }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </li>


        <li style="color: black;padding-top: 19px;">Showing {{1 + (pageSize*(currentPage-1))}} to {{pageSize * (currentPage-1) + data }} of {{total_data_length}} records</li>
    </ul>
    <ul class="pagination">
        <!-- first button -->
        <li [class]="currentPage === 1 ? 'page-item disabled' : 'page-item'" *ngIf="firstLastButtons">
            <button class="page-link" (click)="selectPageNumber(1)"> &laquo; </button>
        </li>
        <!-- previous button -->
        <li [class]="currentPage === 1 ? 'page-item disabled' : 'page-item'" *ngIf="nextPreviousButtons">
            <button class="page-link" (click)="previous()"> &lt; </button>
        </li>
        
        <!-- page numbers -->
        <ng-container *ngFor="let p of visiblePages">
            <li [class]="currentPage === p ? 'page-item active' : 'page-item'">
                <button class="page-link-1" (click)="selectPageNumber(p)">
                    {{ p }} 
                </button>
            </li>
        </ng-container>

        <!-- next button -->
        <li [class]="currentPage === totalPagesCount ? 'page-item disabled' : 'page-item'" *ngIf="nextPreviousButtons">
            <button class="page-link" (click)="next()"> &gt; </button>
        </li>
        <!-- last button -->
        <li [class]="currentPage === totalPagesCount ? 'page-item disabled' : 'page-item'" *ngIf="firstLastButtons">
            <button class="page-link" (click)="selectPageNumber(totalPagesCount)">
                &raquo;
            </button>
        </li>
    </ul>
</nav>